module.exports = __webpack_public_path__ + "assets/img/warrior-name-9482e1a1.png";